<template>
  <div class="flex flex-col justify-center items-center space-y-5">
    <img src="@/assets/adblock.png" width="60" height="60" />
    <p class="text-lg font-medium">
      An error has occured, please disable your ad blocker or try again later.
    </p>
  </div>
</template>
